export const MAX_CHARS = 1000;
export const MAX_RESPONSE_CHARS = 1500;
export const MAX_MESSAGES = 30;

export const INITIAL_MESSAGE = {
  text: "👋 Hi! I'm your ResumeTitan Assistant. I can help you with resume writing, interview preparation, and career advice. How can I assist you today?",
  isUser: false
}; 